import React from "react";

const WhatSetsUsApart = () => {
  const differenceCards = [
    {
      title: "We partner closely with business, tech, and data teams",
      description: "- not in silos, but side by side.",
    },
    {
      title: "We design for production from day one",
      description: "- not just pilot success.",
    },
    {
      title: "We blend strategy and engineering",
      description: "- aligning on outcomes, then building with speed and precision.",
    },
    {
      title: "We bring both human expertise and AI coworkers into every engagement",
      description: "- because we believe the future of delivery is collaborative.",
    },
  ];

  return (
    <div className="w-full py-16 lg:py-14 ">
      <div className="w-[88%] lg:w-[80%] mx-auto">
        {/* Header Section */}
        <div className="mb-12 lg:mb-16">
          <h2 className="text-[32px] lg:text-[48px] xl:text-[56px] text-white RoobertLight leading-[120%] mb-4">
            What sets us apart
          </h2>
        </div>

        {/* Difference Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8 mb-12 lg:mb-16">
          {differenceCards.map((card, index) => (
            <div
              key={index}
              className="bg-white p-6 lg:p-8 flex flex-col justify-start  relative"
            >
              <div className="border-r-4 border-t-4 border-fluoro-green absolute top-0 right-0 w-24 h-24"></div>
              <div className="pl-4">
                <h4 className="text-black RoobertMedium text-[16px] lg:text-[18px] leading-[120%] mb-2">
                  {card.title}
                </h4>
                <p className="text-black RoobertRegular text-[14px] lg:text-[16px] leading-[140%]">
                  {card.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Concluding Section */}
        <div className="space-y-6 mb-8">
          <p className="text-white RoobertRegular text-[16px] lg:text-[18px] leading-[140%]">
            We don't oversell. We don't overbuild. We focus on what matters.
          </p>
          <p className="text-white RoobertRegular text-[16px] lg:text-[18px] leading-[140%]">
            Clients trust us to lead with clarity, deliver with discipline, and leave capability behind - not just code.
          </p>
          <p className="text-white RoobertRegular text-[16px] lg:text-[18px] leading-[140%]">
            We're proud to serve banks, telcos, retailers, and travel companies across ASEAN and ANZ. We're headquartered in Singapore, and locally present in Australia, Indonesia, Malaysia, Philippines, Thailand and Vietnam.
          </p>
          <p className="text-white RoobertRegular text-[16px] lg:text-[18px] leading-[140%] italic">
            And we're just getting started.
          </p>
        </div>

        {/* Call-to-Action Button */}
        <div className="text-left">
          <button className="bg-[#66FF00] text-black px-8 py-4 RoobertSemiBold text-[16px] lg:text-[18px] hover:bg-[#5AE600] transition-colors duration-200">
            Schedule a meeting with us
          </button>
        </div>
      </div>
    </div>
  );
};

export default WhatSetsUsApart; 